import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import * as z from 'zod';
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle
} from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Form, FormControl, FormField, FormItem, FormMessage } from '@/components/ui/form';
import { Loader2 } from 'lucide-react';
import { useState } from 'react';
import { Logo } from '@/components/logos/logo';

const formSchema = z.object({
  shop: z.string().min(1, 'Please enter your store name')
});

const fetchAuthEndpoint = `${import.meta.env.VITE_CONTEXTUAL_API_URL}/shopify/begin`;

export function GettingStartedPage() {
  const [loading, setLoading] = useState(false);

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      shop: ''
    }
  });

  return (
    <main className="h-screen bg-[url('../../public/auth-background.png')] flex">
      <Card className="w-[800px] m-auto">
        <div className="flex space-y-2">
          <div className="w-1/3 p-6 flex flex-col space-y-8">
            <div>
              <Logo icon="contextualWordmark" width={32} height={32} />
            </div>
            <div className="text-4xl font-semibold font-sans">Tell us about your business.</div>
          </div>
          <div className="w-2/3 p-6">
            <CardHeader>
              <CardTitle>Connect to Shopify</CardTitle>
              <CardDescription>{`Connect to Shopify in one-click by entering your MyShopify URL. We'll then automatically verify your store and let you proceed with the rest of the onboarding.`}</CardDescription>
            </CardHeader>
            <CardContent>
              <Form {...form}>
                <form
                  id="getting-started"
                  method="GET"
                  action={fetchAuthEndpoint}
                  onSubmit={() => {
                    setLoading(true);
                  }}
                >
                  <FormField
                    control={form.control}
                    name="shop"
                    render={({ field }) => (
                      <FormItem>
                        <FormControl>
                          <div className="flex justify-center items-center gap-2">
                            <Input
                              {...field}
                              id="shop"
                              name="shop"
                              placeholder="my-store"
                              className="flex-1"
                            />
                            <span>.myshopify.com</span>
                          </div>
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                </form>
              </Form>
            </CardContent>
            <CardFooter className="flex justify-center">
              <Button type="submit" form="getting-started" disabled={loading} className="w-full">
                {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
                Connect
              </Button>
            </CardFooter>
          </div>
        </div>
      </Card>
    </main>
  );
}
